<template>
    {{ displayTitle }}
</template>

<script>
export default {
    name: 'SessionTitle',

    computed: {
        displayTitle() {
            let displayValue = this.session.name
            if (this.session.code) {
                displayValue = this.session.code + ' ' + displayValue
            }
            if (Array.isArray(this.session.tracks) && 0 < this.session.tracks.length) {
                let tracks = ''
                for (let i = 0; i < this.session.tracks.length; ++i) {
                    if ('' !== tracks) {
                        tracks += ', '
                    }
                    tracks += this.session.tracks[i].name
                }
                displayValue += ' (' + tracks + ')'
            }

            return displayValue
        },
    },

    props:
    {
        session: Object,
    },
}
</script>
